import { render, staticRenderFns } from "./ClientViewSingle.vue?vue&type=template&id=506b3fe3&"
import script from "./ClientViewSingle.vue?vue&type=script&lang=js&"
export * from "./ClientViewSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/michaelzickert/Development/capture-studio/capture-studio-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('506b3fe3')) {
      api.createRecord('506b3fe3', component.options)
    } else {
      api.reload('506b3fe3', component.options)
    }
    module.hot.accept("./ClientViewSingle.vue?vue&type=template&id=506b3fe3&", function () {
      api.rerender('506b3fe3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/ClientViewSingle.vue"
export default component.exports